import React from 'react';
import toTitleCase from 'utils/shared/string/toTitleCase';
import { useModal } from 'hooks/useModal';
import { useViewer } from 'hooks/useViewer';
import { ButtonText } from 'components/Button';
import ModalGroup from 'components/modals/ModalGroup';
import CommunityBadge from './CommunityBadge';
import JoinGroup from './JoinGroup';
import { FollowUsProps } from './types';

const FollowWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <div className="hidden h-full flex-col gap-6 rounded-xl border border-color-border-input-lightmode shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)] dark:border-color-border-input-darkmode	md:flex">
        {children}
      </div>
      <div className="flex flex-col md:hidden">{children}</div>
    </>
  );
};

function FollowUs({ items, group, handleMailtoClick, fetchData, clickedSignUp }: FollowUsProps) {
  const {
    isOpen: isJoinGroupOpen,
    openModal: openJoinGroupModal,
    closeModal: closeJoinGroupModal,
  } = useModal();
  const { isAnonymousSession } = useViewer();
  const groupActionUrl = group?.actionUrl;

  return (
    <FollowWrapper>
      <div className="flex flex-col gap-6">
        <div className="flex h-full min-h-[17rem] flex-col gap-6  px-6 pt-6">
          <div className="flex flex-row items-center justify-between">
            <h6 className="typography-product-heading-compact text-color-text-brand dark:text-color-text-brand">
              Follow us
            </h6>
          </div>
          <div className="lg:typography-product-body xs:typography-product-caption flex items-center text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
            <div className="flex flex-col items-start justify-start gap-3">
              <CommunityBadge label={toTitleCase(group?.type)} variant={group?.type} size="sm" />

              {items.map((item, index) => {
                return (
                  <div key={index} className="flex flex-row items-center justify-between gap-2">
                    <span>{item.text ? item.svg : ''}</span>

                    <p className="lg:typography-product-body xs:typography-product-caption text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                      {typeof item.text === 'string' && index === 1 ? (
                        <span className="flex gap-2">
                          {item.text}
                          <ButtonText
                            className="cursor-pointer bg-color-bg-lightmode-primary underline underline-offset-4 dark:bg-color-bg-darkmode-primary"
                            onClick={() => {
                              if (isAnonymousSession) {
                                clickedSignUp && clickedSignUp();
                              } else {
                                handleMailtoClick();
                              }
                            }}
                          >
                            contact me
                          </ButtonText>
                        </span>
                      ) : (
                        <>{item.text}</>
                      )}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="flex items-center px-4 pb-6">
          {!groupActionUrl ? (
            <JoinGroup
              actionHandler={openJoinGroupModal}
              groupId={group.id}
              fetchData={fetchData}
              clickedSignUp={clickedSignUp}
            />
          ) : (
            <JoinGroup
              actionUrl={groupActionUrl}
              groupId={group.id}
              fetchData={fetchData}
              clickedSignUp={clickedSignUp}
            />
          )}
        </div>
        <ModalGroup
          isOpen={isJoinGroupOpen}
          closeModal={closeJoinGroupModal}
          title="Join the group"
          description={`This organizer has not provided a link to join this group yet. We'll let them know you want to join.`}
        />
      </div>
    </FollowWrapper>
  );
}

export default FollowUs;
